import { useState } from 'react';
import { ArrowIcon } from '../Icons';
import IndentedDetailRow from './IndentedDetailRow';
import IndentedRow from './IndentedRow';

const ExpandableEventRow = ({ data, subEvents }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpandSubEvents = () => {
    setIsExpanded((prev) => !prev);
  };

  const visibleColumns = data.columns.slice(1);

  return (
    <>
      <tr
        data-testid="expandable-indented-row"
        className="bg-white border-b-2 whitespace-nowrap cursor-pointer relative"
        onClick={toggleExpandSubEvents}
      >
        {visibleColumns.map((column, index) => {
          const showArrow = index === 0;
          return (
            <td
              key={column.id}
              className={`py-4 px-4 text-center text-black ${index === 0 ? 'pl-[50px]' : ''}`}
            >
              {showArrow && (
                <div className="relative">
                  <div className="absolute left-[-15px]">
                    <ArrowIcon direction={isExpanded ? 'up' : 'down'} />
                  </div>
                </div>
              )}

              <span>{column.value}</span>
            </td>
          );
        })}
      </tr>

      {isExpanded &&
        subEvents.map((subEvent) => {
          return (
            <>
              {subEvent.isDetailSubRow ? (
                <IndentedDetailRow
                  key={subEvent?.eventId}
                  data={subEvent}
                  isLastRow={subEvent?.isLastRow}
                />
              ) : (
                <IndentedRow
                  key={subEvent?.eventId}
                  data={subEvent}
                  isLastRow={subEvent?.isLastRow}
                />
              )}
            </>
          );
        })}
    </>
  );
};

export default ExpandableEventRow;
